export default [{
  path: 'financial/:leftid',
  name: 'merchant_financial',
  component: () => import('@/views/merchant/admin/financial/list'),
  meta: {
    tpflag: 'merchant',
    title: '财务资金',
  }
}, {
  path: 'financialnew/:leftid',
  name: 'merchant_financialnew',
  component: () => import('@/views/merchant/admin/financial/recharge'),
  meta: {
    tpflag: 'merchant',
    title: '充值-财务资金',
  }
}]



// WEBPACK FOOTER //
// ./src/router/user/_financial.js